import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

export default function GradeHeader(props) {
  const { periodWidths, buffer = 0 } = props;

  const {t} = useTranslation("skills_status_report");

  const gradeMap = new Map();
  Object.entries(periodWidths).forEach(([key, val]) => {
    const [grade, season] = key.split("-");
    if (!gradeMap.has(grade)) gradeMap.set(grade, {});

    const gradeData = gradeMap.get(grade);
    gradeMap.set(grade, {
      ...gradeData,
      [season]: val,
    });
  });

  return (
    <div className="header-area">
      <div className="full-header">
        <div className="buffer" style={{ width: buffer, minWidth: buffer }} />
        {[...gradeMap].map(([grade, seasons], index) => (
          <div style={{ backgroundColor: "white", left: buffer }} key={index}>
            <div className="header-box">
              <div className="grade-sticky" style={{ left: buffer }}>
                {t(formatGrade(grade))}
              </div>
            </div>

            <div className="sub">
              {Object.entries(seasons).map(([season, size], index) => (
                <div key={index}>
                  {renderGradeSubHeader(size, season, buffer)}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  function renderGradeSubHeader(size, season, buffer) {
    return (
      <div className="subheader-box" style={{ width: size, minWidth: size }}>
        <div className="grade-sticky" style={{ left: buffer + 3 }}>
          {t(seasonMap[season])}
        </div>
      </div>
    );
  }

  function formatGrade(grade) {
    if (grade === "PRE_K") return "Pre-K";
    if (grade === "KINDERGARTEN") return "Kindergarten";
  
    return `${grades[grade]} Grade`
  }
}

const seasonMap = {
  FALL: "Fall",
  SUMMER: "Summer",
  SPRING: "Spring",
  WINTER: "Winter",
};

const grades = {
  PRE_K: "Pre-K",
  KINDERGARTEN: "Kindergarten",
  FIRST_GRADE: "First",
  SECOND_GRADE: "Second",
  THIRD_GRADE: "Third",
  FOURTH_GRADE: "Fourth",
  FIFTH_GRADE: "Fifth",
};
